import { assets } from "../../publics/assets";

export const dfciVectorTileConfigs = {
  majorRoads: {
    id: "major-roads",
    type: "vector",
    isDynamic: true,
    source: {
      type: "vector",
      tiles: [
        `${process.env.REACT_APP_MAPPER_DFCI_BASEURL_V1}/Road/tiles/major/{z}/{x}/{y}.pbf`,
      ],
      minzoom: 0,
      maxzoom: 22,
    },
    sourceId: "major-roads-source",
    layer: {
      id: "major-roads-layer",
      type: "line",
      source: "major-roads-source",
      sourceLayer: "major",
      minzoom: 0,
      paint: {
        "line-color": "black",
        "line-width": 6,
        "line-opacity": 1,
      },
    },
  },
  secondaryRoads: {
    id: "secondary-roads",
    type: "vector",
    isDynamic: true,
    source: {
      type: "vector",
      tiles: [
        `${process.env.REACT_APP_MAPPER_DFCI_BASEURL_V1}/Road/tiles/secondary/{z}/{x}/{y}.pbf`,
      ],
      minzoom: 10,
      maxzoom: 22,
    },
    sourceId: "secondary-roads-source",

    layer: {
      id: "secondary-roads-layer",
      type: "line",
      source: "secondary-roads-source",

      sourceLayer: "secondary",
      minzoom: 10,
      paint: {
        "line-color": "black",
        "line-width": 4,
        "line-opacity": 1,
      },
    },
  },
  residentialRoads: {
    id: "residential-roads",
    type: "vector",
    isDynamic: true,
    source: {
      type: "vector",
      tiles: [
        `${process.env.REACT_APP_MAPPER_DFCI_BASEURL_V1}/Road/tiles/residential/{z}/{x}/{y}.pbf`,
      ],
      minzoom: 13,
      maxzoom: 22,
    },
    sourceId: "residential-roads-source",

    layer: {
      id: "residential-roads-layer",
      type: "line",
      source: "residential-roads-source",

      sourceLayer: "residential",
      minzoom: 13,
      paint: {
        "line-color": "black",
        "line-width": 3,
        "line-opacity": 1,
      },
    },
  },
  paths: {
    id: "paths",
    type: "vector",
    isDynamic: true,
    source: {
      type: "vector",
      tiles: [
        `${process.env.REACT_APP_MAPPER_DFCI_BASEURL_V1}/Road/tiles/path/{z}/{x}/{y}.pbf`,
      ],
      minzoom: 13,
      maxzoom: 22,
    },
    sourceId: "paths-source",

    layer: {
      id: "paths-layer",
      type: "line",
      source: "paths-source",

      sourceLayer: "path",
      minzoom: 13,
      paint: {
        "line-color": "black",
        "line-width": 2,
        "line-opacity": 1,
      },
    },
  },
  railways: {
    id: "railways",
    type: "vector",
    isDynamic: true,
    source: {
      type: "vector",
      tiles: [
        `${process.env.REACT_APP_MAPPER_DFCI_BASEURL_V1}/railways/tiles/{z}/{x}/{y}.pbf`,
      ],
      minzoom: 0,
      maxzoom: 22,
    },
    sourceId: "railways-source",

    layer: {
      id: "railways-layer",
      type: "line",
      source: "railways-source",
      sourceLayer: "Railways",
      minzoom: 0,
      paint: {
        "line-color": "#503B3B",
        "line-width": 4,
      },
    },
  },
  trainStations: {
    id: "trainStations",
    type: "vector",
    isDynamic: true,
    source: {
      type: "vector",
      tiles: [
        `${process.env.REACT_APP_MAPPER_DFCI_BASEURL_V1}/railways_stations/tiles/{z}/{x}/{y}.pbf`,
      ],
      minzoom: 0,
      maxzoom: 22,
    },
    sourceId: "trainStations-source",
    layer: {
      id: "trainStations-layer",
      type: "circle",
      source: "trainStations-source",
      sourceLayer: "RailwaysStation",
      minzoom: 0,
      paint: {
        "circle-color": "#503B3B",
        "circle-radius": [
          "interpolate",
          ["linear"],
          ["zoom"],
          5,
          5,
          10,
          6,
          14,
          12,
          18,
          18,
        ],
      },
    },
  },
  pools: {
    id: "pools",
    type: "vector",
    isDynamic: true,
    source: {
      type: "vector",
      tiles: [
        `${process.env.REACT_APP_MAPPER_DFCI_BASEURL_V1}/s-pool/tiles/{z}/{x}/{y}.pbf`,
      ],
      minzoom: 0,
      maxzoom: 15,
      promoteId: "id",
    },
    sourceId: "pools-source",
    layers: [
      {
        id: "pools-fill-layer",
        type: "fill",
        source: "pools-source",
        "source-layer": "SwimmingPool",
        minzoom: 0,
        paint: {
          "fill-color": "#2cbccc",
          "fill-opacity": 1,
        },
      },
      {
        id: "pools-symbol-layer",
        type: "symbol",
        source: "pools-source",
        "source-layer": "SwimmingPool",
        minzoom: 5,
        layout: {
          "icon-image": "pools-icon",
          "icon-size": [
            "interpolate",
            ["linear"],
            ["zoom"],
            5,
            0.08,
            10,
            0.06,
            15,
            0.04,
            19,
            0.1,
          ],
          "icon-allow-overlap": false,
          "icon-ignore-placement": false,
          "symbol-sort-key": ["case", ["has", "point_count"], 0, 1],
          "icon-padding": 2,
          "icon-collision-behavior": "cooperative",
        },
        paint: {
          "icon-opacity": ["interpolate", ["linear"], ["zoom"], 6, 0.7, 10, 1],
        },
      },
    ],
    symbol: {
      iconUrl: `${assets.swimmingPoolsIcon}`,
      iconName: "pools-icon",
    },
  },
  fireStations: {
    id: "fireStations",
    type: "vector",
    isDynamic: true,
    source: {
      type: "vector",
      tiles: [
        `${process.env.REACT_APP_MAPPER_DFCI_BASEURL_V1}/FireStation/tiles/{z}/{x}/{y}.pbf`,
      ],
      minzoom: 0,
      maxzoom: 15,
      promoteId: "id",
    },
    sourceId: "fireStations-source",
    layers: [
      {
        id: "fireStations-symbol-layer",
        type: "symbol",
        source: "fireStations-source",
        sourceLayer: "FireStation",
        minzoom: 0,
        maxzoom: 22,
        layout: {
          "icon-image": "firetruck-icon",
          "icon-size": [
            "interpolate",
            ["linear"],
            ["zoom"],
            5,
            0.08,
            10,
            0.06,
            15,
            0.04,
            19,
            0.1,
          ],
          "icon-allow-overlap": false,
          "icon-ignore-placement": false,
          "symbol-sort-key": ["case", ["has", "point_count"], 0, 1],
          "icon-padding": 2,
          "icon-collision-behavior": "cooperative",
        },
        paint: {
          "icon-opacity": ["interpolate", ["linear"], ["zoom"], 6, 0.7, 10, 1],
        },
      },
    ],
    // Symbol image configuration
    symbol: {
      iconUrl: `${assets.fireDepartementIcon}`,
      iconName: "firetruck-icon",
    },
  },
  transformers: {
    id: "transformers",
    type: "vector",
    isDynamic: true,
    source: {
      type: "vector",
      tiles: [
        `${process.env.REACT_APP_MAPPER_DFCI_BASEURL_V1}/electric/transformers/tiles/{z}/{x}/{y}.pbf`,
      ],
      minzoom: 0,
      maxzoom: 22,
    },
    sourceId: "transformers-source",
    layer: {
      id: "transformers-layer",
      type: "circle",
      source: "transformers-source",
      sourceLayer: "Transformers",
      minzoom: 0,
      paint: {
        "circle-color": "orange",
        "circle-radius": [
          "interpolate",
          ["linear"],
          ["zoom"],
          5,
          3,
          10,
          6,
          14,
          10,
          18,
          15,
        ],
      },
    },
  },
  gazLines: {
    id: "gazLines",
    type: "vector",
    isDynamic: true,
    source: {
      type: "vector",
      tiles: [
        `${process.env.REACT_APP_MAPPER_DFCI_BASEURL_V1}/GazLine/gaz_line/tiles/{z}/{x}/{y}.pbf`,
      ],
      minzoom: 0,
      maxzoom: 22,
    },
    sourceId: "gazLines-source",

    layer: {
      id: "gazLines-layer",
      type: "line",
      source: "gazLines-source",
      sourceLayer: "GazLine",
      paint: {
        "line-color": "#FFD700",
        "line-width": 3,
      },
    },
  },
  gazRefuelingStations: {
    id: "gazRefuelingStations",
    type: "vector",
    isDynamic: true,
    source: {
      type: "vector",
      tiles: [
        `${process.env.REACT_APP_MAPPER_DFCI_BASEURL_V1}/GazCarStation/gaz_station/tiles/{z}/{x}/{y}.pbf`,
      ],
      minzoom: 0,
      maxzoom: 22,
    },
    sourceId: "gazRefuelingStations-source",
    layer: {
      id: "gazRefuelingStations-layer",
      type: "circle",
      source: "gazRefuelingStations-source",
      sourceLayer: "GazCarStation",
      minzoom: 0,
      paint: {
        "circle-color": "#FFD700",
        "circle-radius": 7,
      },
    },
  },
  // undergroundElectricalLines: {
  //   id: "underground-electricalLines",
  //   type: "vector",
  //   isDynamic: true,
  //   source: {
  //     type: "vector",
  //     tiles: [
  //       `${process.env.REACT_APP_MAPPER_DFCI_BASEURL_V1}/electric/souterrain/tiles/{z}/{x}/{y}.pbf`,
  //     ],
  //     minzoom: 0,
  //     maxzoom: 22,
  //   },
  //   sourceId: "underground-electricalLines-source",

  //   layer: {
  //     id: "underground-electricalLines-layer",
  //     type: "line",
  //     source: "underground-electricalLines-source",
  //     sourceLayer: "SOUTERRAIN",
  //     paint: {
  //       "line-color": "#8f0707",
  //       "line-width": 4,
  //     },
  //   },
  // },
  // aerianElectricalLines: {
  //   id: "aerian-electricalLines",
  //   type: "vector",
  //   isDynamic: true,
  //   source: {
  //     type: "vector",
  //     tiles: [
  //       `${process.env.REACT_APP_MAPPER_DFCI_BASEURL_V1}/electric/aerien/tiles/{z}/{x}/{y}.pbf`,
  //     ],
  //     minzoom: 0,
  //     maxzoom: 22,
  //   },
  //   sourceId: "aerian-electricalLines-source",

  //   layer: {
  //     id: "aerian-electricalLines-layer",
  //     type: "line",
  //     source: "aerian-electricalLines-source",
  //     sourceLayer: "AERIEN",
  //     paint: {
  //       "line-color": "#FF0000",
  //       "line-width": 4,
  //     },
  //   },
  // },
  electricalLines: {
    id: "electrical-lines",
    type: "vector",
    isDynamic: true,
    source: {
      type: "vector",
      tiles: [
        `${process.env.REACT_APP_MAPPER_DFCI_BASEURL_V1}/electric/lines_all/tiles/{z}/{x}/{y}.pbf`,
      ],
      minzoom: 0,
      maxzoom: 22,
    },
    sourceId: "electrical-lines-source",

    layer: {
      id: "electrical-lines-layer",
      type: "line",
      source: "electrical-lines-source",
      sourceLayer: "ElectricLine_all",
      paint: {
        "line-color": "#FF0000",
        "line-width": 4,
      },
    },
  },
  electricalStationsPoints: {
    id: "electricalStationsPoints",
    type: "vector",
    isDynamic: true,
    source: {
      type: "vector",
      tiles: [
        `${process.env.REACT_APP_MAPPER_DFCI_BASEURL_V1}/electric/station_points_all/tiles/{z}/{x}/{y}.pbf`,
      ],
      minzoom: 0,
      maxzoom: 22,
    },
    sourceId: "electricalStationsPoints-source",
    layer: {
      id: "electricalStationsPoints-layer",
      type: "circle",
      source: "electricalStationsPoints-source",
      sourceLayer: "ElectricStation_points_all",
      minzoom: 0,
      paint: {
        "circle-color": "red",
        "circle-radius": [
          "interpolate",
          ["linear"],
          ["zoom"],
          5,
          3,
          10,
          6,
          14,
          10,
          18,
          15,
        ],
      },
    },
  },
  // crossingPoints: {
  //   id: "crossingPoints",
  //   type: "vector",
  //   isDynamic: true,
  //   source: {
  //     type: "vector",
  //     tiles: [
  //       `${process.env.REACT_APP_MAPPER_DFCI_BASEURL_V1}/electric/cross_point/tiles/{z}/{x}/{y}.pbf`,
  //     ],
  //     minzoom: 0,
  //     maxzoom: 22,
  //   },
  //   sourceId: "crossingPoints-source",
  //   layer: {
  //     id: "crossingPoints-layer",
  //     type: "circle",
  //     source: "crossingPoints-source",
  //     sourceLayer: "UndergroundPassagePoints",
  //     minzoom: 0,
  //     paint: {
  //       "circle-color": "#8800ff",
  //       "circle-radius": 5,
  //     },
  //   },
  // },
  // electricalStationsPoints: {
  //   id: "electricalStationsPoints",
  //   type: "vector",
  //   isDynamic: true,
  //   source: {
  //     type: "vector",
  //     tiles: [
  //       `${process.env.REACT_APP_MAPPER_DFCI_BASEURL_V1}/electric/station_points/tiles/{z}/{x}/{y}.pbf`,
  //     ],
  //     minzoom: 0,
  //     maxzoom: 22,
  //   },
  //   sourceId: "electricalStationsPoints-source",
  //   layer: {
  //     id: "electricalStationsPoints-layer",
  //     type: "circle",
  //     source: "electricalStationsPoints-source",
  //     sourceLayer: "ElectricStation_points",
  //     minzoom: 0,
  //     paint: {
  //       "circle-color": "red",
  //       "circle-radius": [
  //         "interpolate",
  //         ["linear"],
  //         ["zoom"],
  //         5,
  //         3,
  //         10,
  //         6,
  //         14,
  //         10,
  //         18,
  //         15,
  //       ],
  //     },
  //   },
  // },
  // electricalStationsPolygons: {
  //   id: "electricalStationsPolygons",
  //   type: "vector",
  //   isDynamic: true,
  //   source: {
  //     type: "vector",
  //     tiles: [
  //       `${process.env.REACT_APP_MAPPER_DFCI_BASEURL_V1}/electric/station_polygons/tiles/{z}/{x}/{y}.pbf`,
  //     ],
  //     minzoom: 0,
  //     maxzoom: 22,
  //   },
  //   sourceId: "electricalStationsPolygons-source",
  //   layer: {
  //     id: "electricalStationsPolygons-layer",
  //     type: "fill",
  //     source: "electricalStationsPolygons-source",
  //     sourceLayer: "ElectricStation_polygons",
  //     minzoom: 0,
  //     paint: { "fill-color": "red" },
  //   },
  // },
  regions: {
    id: "regions",
    identifyUrl: `${process.env.REACT_APP_MAPPER_DFCI_BASEURL_V1}/Zone/regions/identify/`,
labelKey: "layers.items.regions",
    type: "vector",
    source: {
      type: "vector",
      tiles: [
        `${process.env.REACT_APP_MAPPER_DFCI_BASEURL_V1}/Zone/regions/tiles/{z}/{x}/{y}.pbf`,
      ],
      minzoom: 0,
      maxzoom: 22,
    },
    sourceId: "regions-source",
    layers: [
      {
        id: "regions-fill-invisible",
        type: "fill",
        sourceLayer: "regions",
        minzoom: 0,
        paint: { "fill-color": "transparent", "fill-opacity": 0 },
      },
      {
        id: "regions-layer",
        type: "line",
        sourceLayer: "regions",
        minzoom: 0,
        paint: { "line-color": "blue", "line-width": 2 },
      },
    ],
  },
  departments: {
    id: "departments",
    identifyUrl: `${process.env.REACT_APP_MAPPER_DFCI_BASEURL_V1}/Zone/departments/identify/`,
labelKey: "layers.items.departments",
    type: "vector",
    source: {
      type: "vector",
      tiles: [
        `${process.env.REACT_APP_MAPPER_DFCI_BASEURL_V1}/Zone/departments/tiles/{z}/{x}/{y}.pbf`,
      ],
      minzoom: 0,
      maxzoom: 22,
    },
    sourceId: "departments-source",
    layers: [
      {
        id: "departments-fill-invisible",
        type: "fill",
        sourceLayer: "departments",
        minzoom: 0,
        paint: { "fill-color": "transparent", "fill-opacity": 0 },
      },
      {
        id: "departments-layer",
        type: "line",
        sourceLayer: "departments",
        minzoom: 0,
        paint: { "line-color": "rgba(28, 252, 252, 1)", "line-width": 2 },
      },
    ],
  },
  water: {
    id: "water",
    isDynamic: true,
    type: "vector",
    source: {
      type: "vector",
      tiles: [
        `${process.env.REACT_APP_MAPPER_DFCI_BASEURL_V1}/Water/tiles/{z}/{x}/{y}.pbf`,
      ],
      minzoom: 0,
      maxzoom: 22,
      promoteId: "id",
    },
    sourceId: "water",
    layers: [
      {
        id: "water-layer",
        type: "fill",
        source: "water",
        "source-layer": "Water",
        minzoom: 0,
        paint: {
          "fill-color": "#4682B4",
          "fill-opacity": 1,
        },
      },
      {
        id: "water-symbol-layer",
        type: "symbol",
        source: "water",
        "source-layer": "Water",
        minzoom: 5,
        layout: {
          "icon-image": "water-icon",
          "icon-size": [
            "interpolate",
            ["linear"],
            ["zoom"],
            5,
            0.08,
            10,
            0.06,
            15,
            0.04,
            19,
            0.1,
          ],
          "icon-allow-overlap": false,
          "icon-ignore-placement": false,
          "symbol-sort-key": ["case", ["has", "point_count"], 0, 1],
          "icon-padding": 2,
          "icon-collision-behavior": "cooperative",
        },
        paint: {
          "icon-opacity": ["interpolate", ["linear"], ["zoom"], 6, 0.7, 10, 1],
        },
      },
    ],
    symbol: {
      iconUrl: assets.waterResourcesIcon,
      iconName: "water-icon",
    },
  },
};
